import dynamic from 'next/dynamic';
import __isEmpty from 'lodash/isEmpty';

const destacats = {
    destacatBasic: dynamic(() => import('./DestacatBasic')),
    destacatIdioma: dynamic(() => import('./DestacatIdioma')),
    destacatEsdeveniment: dynamic(() => import('./DestacatEsdeveniment')),
    destacatPoster: dynamic(() => import('./DestacatPoster')),
    default: dynamic(() => import('./DestacatBasic'))
};

export default function Component(props) {
    const { format = 'default' } = props;
    const Destacat = destacats[format];
    if (__isEmpty(Destacat)) return <></>;
    return <Destacat {...props} />;
}
